// Suspense query keys, internal to the api folder.
export const editorialTilesKeys = {
  row: (page: string, previewIds: readonly string[]) =>
    ['editorialTiles', page, previewIds] as const,
};
